/* @ngInject */
const myChangePasswordForm = (
  toaster,
  $$account,
  userService,
  authService
) => {
  return {
    restrict: 'E',
    scope: {

    },
    template: require('./myChangePasswordForm.html'),
    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$account.metadata.fields

      $scope.changePassword = (_currentPassword, _newPassword) => {
        userService.changePassword(authService.getUsername(), _currentPassword, _newPassword)
          .then((message) => {
            toaster.message(message)
            $scope.currentPassword = null
            $scope.newPassword = null
            $scope.passwordConfirmation = null
            $scope.form.$setPristine()
            $scope.form.$setUntouched()
          }, (error) => {
            toaster.error(error)
          })
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myChangePasswordForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/directives/myChangePasswordForm.js